export default __webpack_public_path__ + "static/media/5.79c2a129.png";